import {
    TableCell,
    TableRow,
    Typography,
    IconButton,
    Collapse,
    Box,
    Button,
    Stack,
    MenuItem,
    Menu,
    Divider,
} from '@mui/material';
import React, { useRef, useState } from 'react';
import Iconify from 'src/components/iconify';
import { useTranslation } from 'react-i18next';
import { FormatNumber, glb_sv } from 'src/utils';
import Label from 'src/components/label';
import EmtyData from 'src/components/emty-data';
import ItemRow from './ItemRow';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const Item = ({
    item,
    index,
    STATUS_COLOR,
    dataRef,
    setVisibleReject,
    openRowIndex,
    setOpenRowIndex,
    dataRowSelect,
    dataTakeRef,
    setOpenDrawerSidebar,
    setVisibleImageQR,
    setOpenChangeRequestDevice,
    setVisibleTakDevice,
    setDataCreateNew,
    setVisible,
    setVisiblePutDevice
}) => {
    const { t } = useTranslation();
    const user = glb_sv.userInfo;
    const [openEdit, setOpenEdit] = useState(false);
    const anchorTabEdit = useRef(null);
    return (
        <>
            <TableRow onClick={() => setOpenRowIndex(openRowIndex === index ? null : index)} hover key={index}>
                <TableCell padding="checkbox" />
                <TableCell padding="checkbox">
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpenRowIndex(openRowIndex === index ? null : index);
                        }}
                    >
                        <Iconify icon={openRowIndex === index ? 'mdi:chevron-up' : 'mdi:chevron-down'} />
                    </IconButton>
                </TableCell>
                <TableCell padding="checkbox">{index + 1}</TableCell>
                <TableCell padding="checkbox">
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            setVisibleImageQR(true);
                            dataRef.current = item;
                        }}
                    >
                        <Iconify icon="clarity:qr-code-line" />
                    </IconButton>
                </TableCell>
                <TableCell>
                    <Label color={STATUS_COLOR[item.status]}>{item.status_name}</Label>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="info">
                        {item.code}
                    </Typography>
                </TableCell>
                <TableCell>{item.create_time && glb_sv.formatDate(item.create_time, 'YYYYMMDDHHmmss')}</TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="primary">
                        {item.user_request_nm}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="primary">
                        {item.user_approve_nm}
                    </Typography>
                </TableCell>
                <TableCell>
                    {item.approve_or_reject_date && glb_sv.formatDate(item.approve_or_reject_date, 'YYYYMMDDHHmmss')}
                </TableCell>
                <TableCell>
                    <Typography variant="body2" fontWeight={600}>
                        {FormatNumber(item.total_price)}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="primary">
                        {item.note}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle2" noWrap color="primary">
                        {item.note_reject}
                    </Typography>
                </TableCell>

                <TableCell
                    padding="checkbox"
                    sx={{
                        position: 'sticky',
                        right: 0,
                        backgroundColor: 'white',
                        zIndex: 3,
                        backgroundColor: '#f4f6f8',
                    }}
                    ref={anchorTabEdit}
                >
                    <IconButton
                        size="large"
                        // color={'success'}
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpenEdit(true);
                        }}
                    >
                        <MoreHorizIcon />
                    </IconButton>
                    <Menu
                        anchorEl={anchorTabEdit.current}
                        open={openEdit}
                        onClose={(e) => {
                            e.stopPropagation();
                            setOpenEdit(false);
                        }}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <MenuItem
                            size="large"
                            onClick={(e) => {
                                e.stopPropagation();
                                setOpenEdit(false);
                                setVisible(true);
                                setDataCreateNew(item.list_item);
                            }}
                        >
                            <IconButton
                                color={'info'}
                                disableRipple
                                style={{
                                    padding: 0,
                                    margin: 0,
                                }}
                            >
                                <Iconify color={'info'} icon={'mdi:content-copy'} />
                                <Typography style={{ marginLeft: 10 }}>{t('copy_old_request')}</Typography>
                            </IconButton>
                        </MenuItem>
                        {item.status == 0 && item.user_request_id == user?.id && (
                            <Divider sx={{ my: 0.5, borderStyle: 'dashed' }} />
                        )}

                        {item.status == 0 && item.user_request_id == user?.id && (
                            <MenuItem
                                size="large"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setOpenEdit(false);
                                    setVisibleReject(true);
                                    dataRef.current = item;
                                }}
                            >
                                <IconButton
                                    color={'error'}
                                    disableRipple
                                    style={{
                                        padding: 0,
                                        margin: 0,
                                    }}
                                >
                                    <Iconify color={'error'} icon={'mdi:close-circle-outline'} />
                                    <Typography style={{ marginLeft: 10 }}>{t('cancel')}</Typography>
                                </IconButton>
                            </MenuItem>
                        )}
                    </Menu>
                </TableCell>
            </TableRow>

            {/* Row con */}
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={11}>
                    <Collapse in={openRowIndex === index} timeout="auto" unmountOnExit>
                        <Box>
                            <Typography variant="subtitle2" gutterBottom>
                                {t('detail_request')}
                            </Typography>
                            {item.list_item?.length > 0 ? (
                                item.list_item.map((child, i) => (
                                    <ItemRow
                                        key={child.id}
                                        child={child}
                                        item={item}
                                        dataRowSelect={dataRowSelect}
                                        setOpenDrawerSidebar={setOpenDrawerSidebar}
                                        setOpenChangeRequestDevice={setOpenChangeRequestDevice}
                                        dataTakeRef={dataTakeRef}
                                        setVisibleTakDevice={setVisibleTakDevice}
                                        setVisiblePutDevice={setVisiblePutDevice}
                                    />
                                ))
                            ) : (
                                <EmtyData />
                            )}
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

export default React.memo(Item);
